(function(angular){
	'use strict';

	var goalTeaserObject = {
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		controller: [
			'$filter',
			'mixpanelFactory',
			'ServiceLevelFactory',
			GoalTeaserCardsCtrlFunc
		],
		bindings: {
			isIra: '<',
			selectedRiaPlanId: '=',
			selectedGoal: '=',
			selectedGoalDisplayName: '='
		},
		controllerAs: 'goalTeaser'
	};
	
	angular
		.module('goalTeaserModule')
		.component('goalTeaserCards', goalTeaserObject);

	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/ria/shared/goal-teaser/goal-teaser-cards.html';
	}

	function GoalTeaserCardsCtrlFunc(
		$filter,
		mixpanelFactory,
		ServiceLevelFactory
	) {	
		var goalTeaser = this;
		
		goalTeaser.selectGoal = function(riaPlan){
			mixpanelFactory.track('Existing Investor to RIA Goal Selected', { 'Goal': riaPlan.investmentStrategy });
			goalTeaser.selectedRiaPlanId = riaPlan.id;
			goalTeaser.selectedGoal = riaPlan.investmentStrategy;
			goalTeaser.selectedGoalDisplayName = riaPlan.name;
		};

		goalTeaser.$onInit = function() {
			ServiceLevelFactory.getAvailableRiaPlans('CORE', goalTeaser.isIra)
				.then(function(riaPlans) {
					goalTeaser.plans = {
						'Balanced Investing': $filter('filter')(riaPlans, {'investmentStrategy': 'BALANCED_INVESTING'}, true)[0],
						'Long-Term Growth': $filter('filter')(riaPlans, {'investmentStrategy': 'LONG_TERM_GROWTH'}, true)[0],
						'Supplemental Income': $filter('filter')(riaPlans, {'investmentStrategy': 'SUPPLEMENTAL_INCOME'}, true)[0]
					};
					goalTeaser.selectedRiaPlanId = goalTeaser.plans['Balanced Investing'].id;
					goalTeaser.selectedGoal = goalTeaser.plans['Balanced Investing'].investmentStrategy;
					goalTeaser.selectedGoalDisplayName = goalTeaser.plans['Balanced Investing'].name;
				});
		};
	}
})(window.angular);